import "@/App.css";
import { ReactLenis } from "lenis/react";
import Nav from "@/components/rocky/Nav";
import Hero from "@/components/rocky/Hero";
import Manifesto from "@/components/rocky/Manifesto";
import Verticals from "@/components/rocky/Verticals";
import Markets from "@/components/rocky/Markets";
import Timeline from "@/components/rocky/Timeline";
import Footer from "@/components/rocky/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.4 }}>
      <div className="rocky-page" data-testid="rocky-page">
        <Nav />
        <main>
          <Hero />
          <Manifesto />
          <Verticals />
          <Markets />
          <Timeline />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
